import config from "../config";
import AgentMock from "./mocks/AgentMock";
import { endOfDay, getTime } from "date-fns";
import HTTPService from "./HTTPService";

const useMocks = false;
export default class AgentService {
  static getHeaders() {
    return {
      source: localStorage.getItem(`fieldAgentSource`),
      "X-Authorization-Token": localStorage.getItem(`X-Authorization-Token`),
    };
  }

  static verifyAgent(mobileNumber) {
    if (useMocks === false) {
      const url = `${config.institutionalSalesService}/agentverification/`;
      const data = { phoneNumber: mobileNumber };
      return HTTPService.makeXHRRequest(url, "POST", data, {
        ...this.getHeaders(),
        source: "B2B",
      });
    } else {
      return new Promise((resolve) => {
        window.setTimeout(() => {
          resolve({ data: AgentMock });
        }, 500);
      });
    }
  }

  static getFieldAgentLeads(offset, limit, searchTerm) {
    let agentUserId = localStorage.getItem(`fieldAgentUserId`);
    let agentMobileNum = localStorage.getItem(`fieldAgentMobileNumber`);

    let url = `${config.onlineEcommerceService}/${agentUserId}/purchase-requests/?limit=${limit}&offset=${offset}`;
    if (searchTerm) {
      url += `&searchTerm=${searchTerm}&agentMobileNum=${agentMobileNum}`;
    }

    return HTTPService.makeXHRRequest(url, "GET", null, this.getHeaders());
  }

  static getFieldAgentOrders(
    offset,
    limit,
    searchTerm,
    orderDateRangeFilter,
    orderType,
    myOrders,
    cstOrders,
    fieldOrders,
    partnerOrders
  ) {
    let agentUserId = localStorage.getItem(`fieldAgentUserId`);
    let agentMobileNum = localStorage.getItem(`fieldAgentMobileNumber`);
    let startTime = getTime(new Date(orderDateRangeFilter?.[0]));
    let endTime = getTime(endOfDay(new Date(orderDateRangeFilter?.[1])));

    let url = `${config.onlineEcommerceService}/field-agent/${agentUserId}/orders/?limit=${limit}&offset=${offset}${orderType ? `&orderType=${orderType}` : ""}${myOrders ? `&myOrders=${myOrders}` : ""}${
      cstOrders ? `&cstOrders=${cstOrders}` : ""
    }${fieldOrders ? `&fieldOrders=${fieldOrders}` : ""}${partnerOrders ? `&partnerSelfCheckOutOrders=${partnerOrders}` : ""}`;

    if (searchTerm) {
      url += `&searchTerm=${searchTerm}&agentMobileNum=${agentMobileNum}`;
    }
    if (startTime && endTime) {
      url += `&startTime=${startTime}&endTime=${endTime}`;
    }

    return HTTPService.makeXHRRequest(url, "GET", null, this.getHeaders());
  }

  static fieldAgentApproveOrder(orderId) {
    const payload = { id: orderId };
    let url = `${config.orderManagementService}/v4/approvesaleorder/${orderId}/`;
    return HTTPService.makeXHRRequest(url, "PATCH", payload, this.getHeaders());
  }
  static getFieldAgentTicketOrders(
    pageNumber,
    searchTerm,
    status,
    orderStatus
  ) {
    const agentId = localStorage.getItem(`fieldAgentUserId`);
    const agentMobileNum = localStorage.getItem(`fieldAgentMobileNumber`);
    let url = `${config.orderManagementService}/returnorder/?agentMobileNumber=${agentMobileNum}&tabName=${status}&pageNumber=${pageNumber}&agentUserId=${agentId}`;
    if (searchTerm) {
      url += `&saathiSearchTerm=${searchTerm}`;
    }
    if (orderStatus) {
      url += `&orderStatus=${orderStatus}`;
    }
    return HTTPService.makeXHRRequest(url, "GET", null, this.getHeaders());
  }

  static getReturnOrderDetail(orderId, agentDesignation) {
    let url = `${config.onlineEcommerceService}/ordersummary/?isReturnOrder=true&orderId=${orderId}`;
    return HTTPService.makeXHRRequest(url, "GET", null, this.getHeaders());
  }

  static getCommentsOfOrder(ticketId) {
    const url = `${config.ticketService}/ticket/?ticketUUID=${ticketId}`;
    return HTTPService.makeXHRRequest(url, "GET", null, this.getHeaders());
  }

  static addCommentsForTheOrder(requestBody) {
    console.log(requestBody);
    const url = `${config.ticketService}/ticketcomment/`;
    return HTTPService.makeXHRRequest(
      url,
      "POST",
      requestBody,
      this.getHeaders()
    );
  }

  static approveReturnOrders(requestBody) {
    const url = `${config.orderManagementService}/v4/saleorder/`;
    console.log(url);
    return HTTPService.makeXHRRequest(
      url,
      "PATCH",
      requestBody,
      this.getHeaders()
    );
  }
}
